import { useCallback, useEffect, useState } from "react";
import { environment } from "environment/environment";

const ACCOUNT_NAME = "PK";

const runtimeUrl = () => {
  const separator = environment.angelOneRuntimeMarketDataUrl.includes("?") ? "&" : "?";
  return `${environment.angelOneRuntimeMarketDataUrl}${separator}accountName=${encodeURIComponent(ACCOUNT_NAME)}`;
};

const readJson = async (response) => {
  if (response.status === 404) return null;
  if (!response.ok) {
    throw new Error(`Angel One runtime market-data request failed (${response.status})`);
  }
  return response.json();
};

/**
 * Reads the server-side SmartStream snapshot so the analyser can display the
 * exchange opening price independently from the first calculated Greeks LTP.
 */
export default function useAngelOneRuntimeMarketData(refreshKey) {
  const [snapshot, setSnapshot] = useState(null);
  const [error, setError] = useState(null);

  const load = useCallback(async (signal) => {
    try {
      const response = await fetch(runtimeUrl(), { signal });
      const value = await readJson(response);
      setSnapshot(value && typeof value === "object" ? value : null);
      setError(null);
    } catch (cause) {
      if (cause?.name === "AbortError") return;
      setError(cause);
    }
  }, []);

  useEffect(() => {
    const controller = new AbortController();
    void load(controller.signal);
    return () => controller.abort();
  }, [load, refreshKey]);

  return { snapshot, error, reload: () => load(undefined) };
}
